import React, { createContext, useReducer } from 'react'
import { snackbarReducer, snackbarInitialState } from './reducer'

export const SnackbarContext = createContext({})

export default function SnackbarProvider(props: any) {
  const [state, dispatch] = useReducer(snackbarReducer, snackbarInitialState)

  return (
    <SnackbarContext.Provider value={{ state, dispatch }}>
      {props.children}
    </SnackbarContext.Provider>
  )
}
